import { Box, Container, Flex, Link } from "@chakra-ui/react";
import { ComponentRendering, Placeholder } from "@sitecore-jss/sitecore-jss-nextjs";
import BundleIcon from "src/components/ui/BundleIcon";
import NextLink from "next/link";
import { useHeaderBackground } from "utils/contexts/headerBackgroundContext";
import { useI18n } from "next-localization";

type HeaderProps = {
    params: { [key: string]: string };
    rendering: ComponentRendering;
};

const Header = (props: HeaderProps) => {
    const phKeyCenter = `header-center-${props.params?.DynamicPlaceholderId}`;
    const phKeyRight = `header-right-${props.params?.DynamicPlaceholderId}`;
    const { t } = useI18n();

    const { hasFullBackground, hasWhiteBackground, mobileNavOpen } = useHeaderBackground();

    return (
        <Flex
            as="header"
            sx={{
                height: ["headerMobileTopHeight", null, null, "headerTopHeight"],
                width: "full",
                position: "fixed",
                top: "0",
                zIndex: "header",
                color: !hasFullBackground || hasWhiteBackground ? "black" : "white",
                ...(!hasFullBackground && { backgroundColor: "white" }),
            }}
        >
            <Container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                gap={16}
                variant={"header"}
            >
                <Link
                    as={NextLink}
                    href="/"
                    sx={{
                        zIndex: "headerItem",
                        marginRight: [null, null, null, "auto"],
                        order: [1, null, null, "inherit"],
                    }}
                    aria-label={t("logoLabel")}
                >
                    <BundleIcon
                        name="SimcorpFullLogo"
                        fill="currentColor"
                        width={"144px"}
                        height={"29px"}
                        viewBox="0 0 144 29"
                        sx={{
                            transitionDuration: ".30s",
                            transitionTimingFunction: "ease-in-out",
                            transitionProperty: "color",
                        }}
                    />
                </Link>
                <Placeholder name={phKeyCenter} rendering={props.rendering} />
                <Box
                    sx={{
                        marginLeft: "auto",
                        zIndex: "headerItem",
                        display: [mobileNavOpen ? "flex" : "none", null, null, "block"],
                        ...(mobileNavOpen && {
                            bottom: { base: "sp24", lg: "auto" },
                            left: { base: "0", lg: "auto" },
                            width: { base: "full", lg: "auto" },
                            px: { base: "sp16", lg: 0 },
                            position: { base: "fixed", lg: "static" },
                        }),
                    }}
                >
                    <Placeholder name={phKeyRight} rendering={props.rendering} />
                </Box>
            </Container>
        </Flex>
    );
};

export default Header;
